module.exports = __webpack_public_path__ + "static/Jak-dziala-system-CRM-1e9eea3d234fb61423ff5e046cd93466.jpg";